import styled from "styled-components";

export const Wrapper = styled.div<{ row?: boolean; align?: string }>`
  gap: 1em;
  display: flex;
  flex-direction: ${({ row }) => (row ? "row" : "column")};
  align-items: ${({ align }) => align || "flex-start"};
  background-color: white; //temporary

  .ant-select {
    min-width: 200px;
  }
  .actions {
    align-self: flex-end;
  }
  .anticon.anticon-double-right {
    font-size: 24px;
    margin-top: 30px;
  }
`;
